export default {
    profile: "Profile",
    company: "Company",
    users: "Users",
    "my-account": "My Account",
    "profile-tab": {
        "change-password": "Change password",
        "save-changes": "Save changes",
        "e-mail": "E-mail",
        "document-type": "Document Type",
        "document-number": "Document Number",
        "preferred-language": "Preferred language",
        "recover-tfa": "Recover 2FA",
        "enable-tfa": "Enable 2FA",
        "disable-tfa": "Disable 2FA",
        "gtn-profile": "GTN Profile",
        "2fa": "Two-factor authentication",
        profile: "Profile",
        name: "Name",
        cancel: "Cancel",
        country: "Country",
        security: "Security",
        password: "Password",
        "enterprise-account": "Enterprise Account",
        "personal-account": "Personal Account",
        "preferred-name": "Preferred name",
        "uses-preferred-name": "Uses a preferred name",
        "job-description": "Job description",
    },
    "company-tab": {
        "company-name": "Company name",
        industry: "Industry",
        "trade-name": "Trade Name",
        "company-size": "Company Size",
        website: "Website",
        "document-type": "Document Type",
        "document-number": "Document Number",
        "edit-company": "Edit company",
        contact: "Contact",
        "edit-contacts": "Edit contacts",
        name: "Name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        "address-type": "Address Type",
        "postal-code": "Postal Code",
        country: "Country",
        state: "State",
        city: "City",
        neighborhood: "Neighborhood",
        street: "Street",
        number: "Number",
        complement: "Complement (Optional)",
        "edit-address": "Edit address",
        "modal-edit-company": {
            "edit-company": "Edit company",
            "company-name": "Company name",
            "company-name-required": "Company name is required",
            "trade-name": "Trade name",
            "trade-name-required": "Trade name is required",
            "company-size": "Company size",
            "company-size-required": "Company size is required",
            segmentation: "Segmentation",
            industry: "Industry",
            "industry-required": "Industry is required",
            website: "Website",
            "website-required": "Website is required",
            "document-type": "Document type",
            "document-type-required": "Document type is required",
            document: "Document",
            "document-required": "Document is required",
            cancel: "Cancel",
            save: "Save Changes",
        },
        "modal-edit-address": {
            "edit-companys-address": "Edit company's addresses",
            address: "Address",
            "remove-address": "Remove address",
            "add-address": "Add another address",
            cancel: "Cancel",
            save: "Save Changes",
            "address-type": "Address Type",
            "address-type-required": "Address Type is required",
            "zip-code": "Zip/Postal Code",
            "zip-code-required": "Zip/Postal Code is required",
            country: "Country",
            "country-required": "Country is required",
            state: "State",
            "state-required": "State is required",
            city: "City",
            "city-required": "City is required",
            neighborhood: "Neighborhood",
            "neighborhood-required": "Neighborhood is required",
            street: "Street",
            "street-required": "Street is required",
            number: "Number",
            "number-required": "Number is required",
            complement: "Complement",
        },
        "modal-edit-contact": {
            "edit-companys-contact": "Edit company's contacts",
            contact: "Contact",
            "remove-contact": "Remove contact",
            "add-contact": "Add another contact",
            cancel: "Cancel",
            save: "Save Changes",
            "contact-type": "Contact Type",
            "contact-type-required": "Contact Type is required",
            "first-name": "First Name",
            "first-name-required": "First Name is required",
            "last-name": "Last Name",
            "last-name-required": "Last Name is required",
            email: "Email",
            "email-required": "Email is required",
            "country-code": "Country Code",
            "country-code-required": "Country Code is required",
            "phone-number": "Phone Number",
            "phone-number-required": "Phone Number is required",
        },
    },
    "users-tab": {
        modal: {
            "remove-user": {
                title: "Remove user",
                subtitleFirstPart: "By confirming the removal, the user",
                subtitleLastPart: "will no longer be part of this account and will loose access to all its features.",
            },
            "change-owner": {
                title: "Change owner?",
                subtitleFirstPart: "There can only be one owner per company. By confirming, this user",
                subtitleLastPart: "will be the sole owner of this company.",
            },
            "change-employee": {
                title: "Change to employee",
                subtitleFirstPart: "By confirming, this user",
                subtitleLastPart: "will be a employee of this company.",
            },
            "change-admin": {
                title: "Change to admin",
                subtitleFirstPart: "By confirming, this user",
                subtitleLastPart: "will be a admin of this company.",
            },
            "add-user": {
                title: "Add user",
                subtitleFirstPart: "By confirming, the user",
                subtitleLastPart: "will be added as an employee this company.",
            },
            buttons: {
                cancel: "cancel",
                confirm: "confirm",
            },
        },
        "add-user-button": "Add user",
        "table-columns": {
            name: "name",
            "last-access": "Last access",
            role: "role",
        },
        "new-access-request": "new access request(s)",
        "users-email": "User's email",
        "users-not-found": "Users not found.",
    },
    "rock-content-team": "Rock Content's Team",
    "no-rock-content-team": "No Rock Content's team",
};
